import { useCallback } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as server from '../server';
import { useDynamicReducerDispatch } from '../store';
import * as actions from '../store/actions';

export const useFetchExternalBalance = () => {
    const translate = useComponentTranslations();
    const dynamicReducerDispatch = useDynamicReducerDispatch();

    return useCallback(async () => {
        try {
            const response = await server.getExternalBalance();
            const { currencyCode, amount } = response.data.balance;

            dynamicReducerDispatch(actions.setExternalBalance({ currencyCode, amount }));
        } catch (error) {
            dynamicReducerDispatch(actions.setExternalBalance({ message: translate('balance.external.error') }));
        }
    }, [
        dynamicReducerDispatch,
        translate
    ]);
};
